import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { isEmpty } from 'lodash';

@Component({
  selector: 'app-upload-treatment-select-files',
  templateUrl: './upload-treatment-select-files.component.html',
  styleUrls: ['./upload-treatment-select-files.component.scss']
})
export class UploadTreatmentSelectFilesComponent implements OnInit {

  @ViewChild('inputFileEl') inputFileEl: ElementRef;

  @Output() onSelectFiles: EventEmitter<File[]> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  selectFiles(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.inputFileEl) {
      this.inputFileEl.nativeElement.value = null;
      this.inputFileEl.nativeElement.click();
    }
  }

  filesSelectChange(event) {
    if (event.target.files && !isEmpty(event.target.files)) {
      this.onSelectFiles.emit(event.target.files);
      console.log(event.target.files);
    }
  }


}
